import { __rest } from 'tslib';
import React from 'react';
import { GroupRoot } from './styled.js';

const Group = React.forwardRef((_a, ref) => {
    var { layout = 'horizontal' } = _a, props = __rest(_a, ["layout"]);
    return React.createElement(GroupRoot, Object.assign({}, props, { ref: ref, "$layout": layout }));
});
Group.displayName = 'Checkbox.Group';

export { Group };
//# sourceMappingURL=Group.js.map
